import { SsoSDK } from '@q-auth/auth-sdk'
import { FAT_AUTH_ORIGIN, FAT_CLIENT_ID, QAUTH_POOL_CODE, getOAuthCallbackUrl } from './oauth'
import { clearLoginSession } from './auth'
import { clearLoginSource } from './loginBackRecovery'

export async function logoutFromSso({ sdk, revokeSession, onLocalLogout }) {
  try {
    await revokeSession()
  } catch (error) {
    // 业务撤销失败也继续清理本地态并通知认证中心。
    console.warn('业务会话撤销失败，继续统一登出', error)
  } finally {
    clearLoginSession()
    clearLoginSource()
    onLocalLogout()
  }
  const activeSdk = sdk ?? new SsoSDK({
    client_id: FAT_CLIENT_ID,
    code: QAUTH_POOL_CODE,
    sso_origin: FAT_AUTH_ORIGIN,
    redirect_uri: getOAuthCallbackUrl(),
  })
  // 按接入要求使用隐藏 iframe 通知，不离开当前页面。
  // 跨站无痕/iOS Safari 第三方 Cookie 限制可能导致认证中心会话仍然存在。
  if (typeof activeSdk.logout !== 'function') {
    throw new Error('认证组件不支持登出，请刷新页面后重试')
  }
  activeSdk.logout()
}